class VariantPicker extends HTMLElement {
  connectedCallback(){this.variants=JSON.parse(this.querySelector('[data-variants-json]')?.textContent||'[]');this.addEventListener('change',this.onChange.bind(this));this.update(false)}
  options(){return [...this.querySelectorAll('[data-option-position]')].sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition)).map(group=>{const checked=group.querySelector('input:checked');const select=group.querySelector('select');return checked?.value||select?.value})}
  onChange(){this.update(true)}
  update(push){const opts=this.options();const variant=this.variants.find(v=>v.options.every((o,i)=>o===opts[i]));const scope=this.closest('[data-product-root]')||document;const id=scope.querySelector('[name=id]');const submit=scope.querySelector('[data-product-submit]');if(!variant){id&&(id.value='');if(submit){submit.disabled=true;submit.textContent=window.HarmainTheme.strings.unavailable}return}id&&(id.value=variant.id);scope.querySelectorAll('[data-product-price]').forEach(el=>el.textContent=window.HarmainTheme.formatMoney(variant.price));scope.querySelectorAll('[data-compare-price]').forEach(el=>{el.textContent=variant.compare_at_price>variant.price?window.HarmainTheme.formatMoney(variant.compare_at_price):'';el.hidden=!(variant.compare_at_price>variant.price)});scope.querySelectorAll('[data-product-sku]').forEach(el=>el.textContent=variant.sku||'—');// Update selected option labels (e.g. "Length: 6 inch")
this.querySelectorAll('[data-selected-option]').forEach((el,i)=>{if(opts[i]!==undefined)el.textContent=opts[i]});

// Update price if scope missed it (fallback to document)
if(!scope.querySelector('[data-product-price]'))document.querySelectorAll('[data-product-price]').forEach(el=>el.textContent=window.HarmainTheme.formatMoney(variant.price));
scope.querySelectorAll('[data-inventory-status]').forEach(el=>{el.textContent=variant.available?'In stock':'Out of stock';el.classList.toggle('inventory-status--in',variant.available);el.classList.toggle('inventory-status--out',!variant.available)});if(submit){submit.disabled=!variant.available;submit.textContent=variant.available?submit.dataset.availableText:window.HarmainTheme.strings.soldOut}if(variant.featured_media?.id)document.querySelector(`[data-media-id="${variant.featured_media.id}"]`)?.click();if(push&&history.replaceState){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url)}}
}
customElements.define('variant-picker',VariantPicker);

class ProductForm extends HTMLElement {}
customElements.define('product-form',ProductForm);

(() => {const root=document.querySelector('[data-product-root][data-product-handle]');if(root){const key='harmain-recently-viewed';let items=[];try{items=JSON.parse(localStorage.getItem(key)||'[]')}catch{}items=[root.dataset.productHandle,...items.filter(x=>x!==root.dataset.productHandle)].slice(0,12);localStorage.setItem(key,JSON.stringify(items))}})();

/* Custom branded Buy It Now button */
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-buy-now]');

  if (!button || button.disabled) return;

  const form = button.closest('form[data-product-form]');

  if (!form) return;

  event.preventDefault();

  const errorBox = form.querySelector('[data-buy-now-error]');
  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Processing…';

  if (errorBox) {
    errorBox.hidden = true;
    errorBox.textContent = '';
  }

  try {
    const formData = new FormData(form);

    const response = await fetch(
      window.HarmainTheme.routes.cartAdd,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Unable to continue to checkout.'
      );
    }

    const rootPath =
      window.Shopify?.routes?.root || '/';

    window.location.assign(`${rootPath}checkout`);
  } catch (error) {
    if (errorBox) {
      errorBox.textContent = error.message;
      errorBox.hidden = false;
    } else {
      window.HarmainTheme.live(error.message);
    }

    button.disabled = false;
    button.textContent = originalText;
  }
});

/* Match Buy It Now availability with selected variant */
document.addEventListener('change', event => {
  const root = event.target.closest('[data-product-root]');

  if (!root) return;

  requestAnimationFrame(() => {
    const addButton =
      root.querySelector('[data-product-submit]');

    const buyButton =
      root.querySelector('[data-buy-now]');

    if (addButton && buyButton) {
      buyButton.disabled = addButton.disabled;
    }
  });
});